import { MarketTemplate, EntityTypes } from "../data";
/* tslint:disable:no-null-keyword */
export const emptyMarket = {
    id: "",
    name: "",
    betslipLine: "",
    marketType: {
        id: "",
        name: "",
        isCastMarket: false
    },
    sportId: "",
    leagueId: "",
    startDate: "",
    title: null,
    participantMapping: null,
    eventId: "",
    entityType: EntityTypes.Market,
    isLive: false,
    isSuspended: false,
    liveData: null,
    metadata: {},
    tags: [""],
    groups: [""],
    inMarketGroups: [{
            id: "",
            sortingKey: 0
        }],
    castMarkets: null,
    template: MarketTemplate.ThreeBox,
    selections: [],
    isEmpty: true,
    mbnIcon: {
        active: false,
        tagNumber: 0
    }
};
//# sourceMappingURL=emptyMarket.js.map